import type {
  AppProfileWithId,
  AppSpec,
  AppStruct,
  ConnectorStruct,
  TriggerIntegrationSpec,
} from '@cohort/shared/schema/apps/app';
import {GoogleFitBeActiveTriggerIntegrationSpec} from '@cohort/shared/schema/apps/google-fit/triggers/beActive';
import {GoogleFitCompleteActivityTriggerIntegrationSpec} from '@cohort/shared/schema/apps/google-fit/triggers/completeActivity';
import type {OAuth2AppCredentials, OAuth2Credentials} from '@cohort/shared/schema/apps/oauth';
import {basicOauth2ConnectorSpec} from '@cohort/shared/schema/apps/oauth';

export const GoogleFitTriggerIntegrationSpecs = [
  GoogleFitBeActiveTriggerIntegrationSpec,
  GoogleFitCompleteActivityTriggerIntegrationSpec,
] as const satisfies ReadonlyArray<TriggerIntegrationSpec>;

type GoogleFitTriggerIntegrationIds = (typeof GoogleFitTriggerIntegrationSpecs)[number]['id'];

export type GoogleFitConnectorStruct = ConnectorStruct<
  'google-fit',
  OAuth2AppCredentials,
  OAuth2Credentials,
  AppProfileWithId,
  null
>;

export type GoogleFitAppStruct = AppStruct<
  'google-fit',
  null,
  GoogleFitConnectorStruct,
  null,
  never,
  never,
  never,
  GoogleFitTriggerIntegrationIds,
  never,
  never
>;

export const GoogleFitConnectorSpec =
  basicOauth2ConnectorSpec<GoogleFitConnectorStruct>('google-fit');

export const GoogleFitAppSpec: AppSpec<GoogleFitAppStruct> = {
  id: 'google-fit',
  name: 'Google Fit',
  merchantConnector: null,
  userConnector: GoogleFitConnectorSpec,
  usersSyncSpec: null,
  actionSpecs: [],
  notificationIntegrationSpecs: [],
  perkIntegrationSpecs: [],
  triggerIntegrationSpecs: GoogleFitTriggerIntegrationSpecs,
  userEventSpecs: [],
  resourceSpecs: [],
};
